import * as React from "react"

type Props = {
  image?: string | null,
  name: string,
};

const Avatar: React.FunctionComponent<Props> = ({ image, name }) => {
  let initials = name.split(" ").map((n,i,a)=> i === 0 || i+1 === a.length ? n[0] : null).join("");

  return (
    <div className="position-relative u-lg-avatar mr-3">
      {image && <img className="rounded-circle" src={image} alt={name} width={80} height={80} /> }
      {!image && <span className="btn btn-lg btn-icon btn-soft-info rounded-circle mr-2">
        <span className="btn-icon__inner">{initials}</span>
      </span>}
    </div>
  )
}

export default Avatar
